<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit Pack" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-pack-form [pack]="pack" *ngIf="pack"></app-pack-form>
        </form>
      </div>
    </section>
  </div>
</div>
